import script from "./SchoolAdminsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./SchoolAdminsTable.vue?vue&type=script&lang=ts&setup=true"

import "./SchoolAdminsTable.vue?vue&type=style&index=0&id=c243ce4e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c243ce4e"]])

export default __exports__